import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface ValidationState {
    containedInLikely: boolean;
    othersInLikely: boolean;
    correctDiagnosis: string;
    comment: string;
    ratingEducational: number;
    ratingClinical: number;
    commentQualityOfLive: string;
}

const initialState: ValidationState = {
   containedInLikely: false,
   othersInLikely: false,
   correctDiagnosis: "",
   comment: "",
   ratingEducational: 0,
   ratingClinical: 0,
   commentQualityOfLive: ""
}

export const validationSlice = createSlice({
    name: 'validation',
    initialState,
    reducers: {
        setValidationInfo: (state, action: PayloadAction<{containedInLikely: boolean, othersInLikely: boolean, correctDiagnosis: string, comment: string, ratingEducational: number, ratingClinical: number, commentQualityOfLive: string}>) => {
            state.containedInLikely = action.payload.containedInLikely;
            state.othersInLikely = action.payload.othersInLikely;
            state.correctDiagnosis = action.payload.correctDiagnosis;
            state.comment = action.payload.comment;
            state.ratingEducational = action.payload.ratingEducational;
            state.ratingClinical = action.payload.ratingClinical;
            state.commentQualityOfLive = action.payload.commentQualityOfLive;
        }
    }
});

export const { setValidationInfo } = validationSlice.actions;

export const selectValidation = (state: RootState) => state.validation;

export default validationSlice.reducer;